// Taux de change fixes (base EUR) — fonctionnement 100% hors-ligne
// Source: moyennes approximatives début 2026 — mise à jour recommandée tous les 6 mois

import { detectCountry } from "./emergencyData";

export const CURRENCY_RATES = {
  EUR: { rate: 1,      symbol: "€",  name: "Euro",                  flag: "🇪🇺" },
  USD: { rate: 1.08,   symbol: "$",  name: "Dollar américain",       flag: "🇺🇸" },
  GBP: { rate: 0.85,   symbol: "£",  name: "Livre sterling",         flag: "🇬🇧" },
  JPY: { rate: 165,    symbol: "¥",  name: "Yen japonais",           flag: "🇯🇵" },
  THB: { rate: 38,     symbol: "฿",  name: "Baht thaïlandais",       flag: "🇹🇭" },
  VND: { rate: 27000,  symbol: "₫",  name: "Dong vietnamien",        flag: "🇻🇳" },
  IDR: { rate: 17500,  symbol: "Rp", name: "Roupie indonésienne",    flag: "🇮🇩" },
  INR: { rate: 92,     symbol: "₹",  name: "Roupie indienne",        flag: "🇮🇳" },
  LKR: { rate: 335,    symbol: "Rs", name: "Roupie sri-lankaise",    flag: "🇱🇰" },
  MVR: { rate: 16.6,   symbol: "Rf", name: "Rufiyaa maldivien",      flag: "🇲🇻" },
  KHR: { rate: 4400,   symbol: "៛",  name: "Riel cambodgien",        flag: "🇰🇭" },
  MAD: { rate: 10.8,   symbol: "د.م", name: "Dirham marocain",       flag: "🇲🇦" },
  TND: { rate: 3.3,    symbol: "د.ت", name: "Dinar tunisien",        flag: "🇹🇳" },
  EGP: { rate: 53,     symbol: "£E", name: "Livre égyptienne",       flag: "🇪🇬" },
  TRY: { rate: 36,     symbol: "₺",  name: "Livre turque",           flag: "🇹🇷" },
  ZAR: { rate: 20,     symbol: "R",  name: "Rand sud-africain",      flag: "🇿🇦" },
  NAD: { rate: 20,     symbol: "N$", name: "Dollar namibien",        flag: "🇳🇦" },
  BWP: { rate: 13,     symbol: "P",  name: "Pula botswanais",        flag: "🇧🇼" },
  KES: { rate: 145,    symbol: "KSh", name: "Shilling kényan",       flag: "🇰🇪" },
  MGA: { rate: 4900,   symbol: "Ar", name: "Ariary malgache",        flag: "🇲🇬" },
  MUR: { rate: 50,     symbol: "₨",  name: "Roupie mauricienne",     flag: "🇲🇺" },
  XOF: { rate: 655,    symbol: "CFA", name: "Franc CFA (Sénégal)",   flag: "🌍" },
  CAD: { rate: 1.48,   symbol: "C$", name: "Dollar canadien",        flag: "🇨🇦" },
  MXN: { rate: 19,     symbol: "$",  name: "Peso mexicain",          flag: "🇲🇽" },
  BRL: { rate: 5.6,    symbol: "R$", name: "Réal brésilien",         flag: "🇧🇷" },
  PEN: { rate: 4.0,    symbol: "S/", name: "Sol péruvien",           flag: "🇵🇪" },
  ARS: { rate: 1050,   symbol: "$",  name: "Peso argentin",          flag: "🇦🇷" },
  AUD: { rate: 1.66,   symbol: "A$", name: "Dollar australien",      flag: "🇦🇺" },
  NZD: { rate: 1.80,   symbol: "NZ$", name: "Dollar néo-zélandais",  flag: "🇳🇿" },
  AED: { rate: 3.97,   symbol: "د.إ", name: "Dirham émirien",        flag: "🇦🇪" },
};

// Country → currency code mapping
const COUNTRY_CURRENCY = {
  SPAIN: "EUR", PORTUGAL: "EUR", ITALY: "EUR", GREECE: "EUR",
  GERMANY: "EUR", REUNION: "EUR",
  UK: "GBP",
  TURKEY: "TRY",
  MOROCCO: "MAD",
  EGYPT: "EGP",
  TUNISIA: "TND",
  SENEGAL: "XOF",
  SOUTH_AFRICA: "ZAR",
  NAMIBIA: "NAD",
  BOTSWANA: "BWP",
  KENYA: "KES",
  MADAGASCAR: "MGA",
  MAURITIUS: "MUR",
  JAPAN: "JPY",
  THAILAND: "THB",
  VIETNAM: "VND",
  CAMBODIA: "KHR",
  INDONESIA: "IDR",
  INDIA: "INR",
  SRI_LANKA: "LKR",
  MALDIVES: "MVR",
  USA: "USD",
  CANADA: "CAD",
  MEXICO: "MXN",
  BRAZIL: "BRL",
  PERU: "PEN",
  ARGENTINA: "ARS",
  AUSTRALIA: "AUD",
  NEW_ZEALAND: "NZD",
};

export function getCurrencyForDestination(destination = "") {
  const country = detectCountry(destination);
  return COUNTRY_CURRENCY[country] || "EUR";
}
